import { render, staticRenderFns } from "./AdMdSec.vue?vue&type=template&id=481c374f&scoped=true"
import script from "./AdMdSec.vue?vue&type=script&lang=js"
export * from "./AdMdSec.vue?vue&type=script&lang=js"
import style0 from "./AdMdSec.vue?vue&type=style&index=0&id=481c374f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481c374f",
  null
  
)

export default component.exports